import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

export function AuthedFooter() {
  return (
    <div className="background">
      <div className="footer_new">
        <div className="footer__img">
          <a
            href="https://buypower.ng/merchant"
            target="_blank"
            rel="noopener noreferrer"
          >
            Merchant
          </a>
          <Link to="/privacy-policy"> Privacy Policy </Link>
          <Link to="/terms-of-use"> Terms </Link>
              <Link to="/media-kit">Media Kit</Link>
          <a
            href="https://buypower.ng/about"
            target="_blank"
            rel="noopener noreferrer"
          >
            About Us
          </a>
        </div>
        <div>© BuyPower Inc | All Rights Reserved</div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/AuthedFooter.js